export const promoVersion = (state) => state.promo.promo;
export const emailPromo = (state) => state.promo.email;
